import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ExternalEQueryAccessionInfo } from './external-e-query-accession-info';
import { Router } from '@angular/router';
import { EQueryAccessionInfo } from '../../admin/shared/e-query-accession-info';

@Component({
    selector: 'e-query-accession-info',
    template: require('./e-query-accession-info.component.html'),
    styles: [require('./e-query-accession-info.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EQueryAccessionInfoComponent {
    @Input()
    public isToggled = false;

    @Input()
    public accessionInfo: ExternalEQueryAccessionInfo | EQueryAccessionInfo;

    @Input()
    public screenResultLinkNeeded = true;

    @Input()
    public screenResultUrl: any[];

    @Output()
    public onGoToScreenResultClick = new EventEmitter();

    public get isExternalAccessionInfo(): boolean {
        return this.accessionInfo instanceof ExternalEQueryAccessionInfo;
    }
    
    constructor(private readonly router: Router) {
    }

    public goToScreenResult(): void {
        const serializedAccessionNumber = JSON.stringify([this.accessionInfo.accessionNumber]);
        const accessionNumberQueryParam = { accessionNumber: serializedAccessionNumber };
        const urlTree = this.router.createUrlTree(this.screenResultUrl, {queryParams: accessionNumberQueryParam});
        delete urlTree.root.children['global-popup'];
        this.router.navigateByUrl(urlTree)
            .then(() => this.onGoToScreenResultClick.emit());
    }
}
